<template>
    <div id="install-code">
        <div class="left">
            <div class="quick-installation">
                <h2 v-if="!settingInitialized">{{ $t("fastWizard.installationAndInstructions") }}</h2>
                <h4 class="mt-2">{{ $t("fastWizard.installationTrackingCode") }}</h4>
                <a-alert
                    :message="$t('fastWizard.installationTrackingCodePlease', { bodyTag: '<' + '/' + 'head>' })"
                    type="warning"
                    show-icon
                    class="mb-1"
                />

                <prism-editor
                    :value="integrationScript()"
                    class="my-editor"
                    :highlight="highlighter"
                    :line-numbers="false"
                    readonly
                />
                <a-button
                    type="primary"
                    @click="copyTextToClipboard"
                    class="mt-2 btnColor"
                    style="width: 100px"
                    danger
                    ghost
                >
                    {{ $t("fastWizard.installationInstructionsCopy") }}
                </a-button>
            </div>

            <div class="platforms platforms-container">
                <div
                    class="platform platform-content"
                    @click="selectedPlatform = selectedPlatform === 'Instructions' ? null : 'Instructions'"
                    :class="{ selected: selectedPlatform === 'Instructions' }"
                >
                    <div class="header">
                        <h4 class="mt-2">{{ $t("fastWizard.installationInstructions") }}</h4>
                        <span class="down-arrow">{{ $t("message.expandSectionArrow") }}</span>
                    </div>
                    <div class="content" v-show="selectedPlatform === 'Instructions'">
                        <div
                            class="platform platform-integration"
                            @click.stop="selectedPlatform2 = selectedPlatform2 === 'js' ? false : 'js'"
                            :class="{ selected: selectedPlatform === 'js' }"
                        >
                            <div class="header">
                                <JSIcon style="width: 32px; height: 32px" />
                                <span style="margin-right: 18px">{{ $t("fastWizard.platformJavascript") }}</span>
                                <span></span>
                            </div>
                            <div class="content" v-if="selectedPlatform2 === 'js'">
                                <div>
                                    {{
                                        $t("fastWizard.installationInstructionsJavascript", {
                                            bodyTag: "<" + "/" + "body>",
                                        })
                                    }}
                                </div>
                            </div>
                        </div>
<!--                        <div-->
<!--                            class="platform platform-integration"-->
<!--                            @click.stop="selectedPlatform2 = selectedPlatform2 === 'shopify' ? null : 'shopify'"-->
<!--                            :class="{ selected: selectedPlatform2 === 'shopify' }"-->
<!--                        >-->
<!--                            <div class="header">-->
<!--                                <ShopifyIcon style="width: 32px; height: 32px" />-->
<!--                                <span style="margin-right: 18px">Shopify</span>-->
<!--                                <span></span>-->
<!--                            </div>-->
<!--                            <div class="content" v-if="selectedPlatform2 === 'shopify'">-->
<!--                                <div>{{ $t("fastWizard.installationInstructionsShopify1") }}</div>-->
<!--                                <div>-->
<!--                                    {{ $t("fastWizard.installationInstructionsShopify2") }}-->
<!--                                </div>-->
<!--                                <div>-->
<!--                                    {{-->
<!--                                        $t("fastWizard.installationInstructionsShopify3", {-->
<!--                                            bodyTag: "<" + "/" + "body>",-->
<!--                                        })-->
<!--                                    }}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                        <div
                            class="platform platform-integration"
                            @click.stop="selectedPlatform2 = selectedPlatform2 === 'ideasoft' ? null : 'ideasoft'"
                            :class="{ selected: selectedPlatform === 'ideasoft' }"
                        >
                            <div class="header">
                                <img
                                    src="/static/img/ideasoft.png"
                                    :alt="$t('fastWizard.imageAltLoader')"
                                    style="width: 102px; height: 32px"
                                />
                                <span style="margin-right: 75px">{{ $t("fastWizard.platformIdeaSoft") }}</span>
                                <span></span>
                            </div>
                            <div class="content" v-if="selectedPlatform2 === 'ideasoft'">
                                <div>{{ $t("fastWizard.installationInstructionsIdeaSoft1") }}</div>
                                <div>{{ $t("fastWizard.installationInstructionsIdeaSoft2") }}</div>
                                <div>{{ $t("fastWizard.installationInstructionsIdeaSoft3") }}</div>
                                <div>{{ $t("fastWizard.installationInstructionsIdeaSoft4") }}</div>
                                <div>{{ $t("fastWizard.installationInstructionsIdeaSoft5") }}</div>
                            </div>
                        </div>
                        <div
                            class="platform platform-integration"
                            @click.stop="selectedPlatform2 = selectedPlatform2 === 'wordpress' ? null : 'wordpress'"
                            :class="{ selected: selectedPlatform === 'wordpress' }"
                        >
                            <div class="header">
                                <WordPressIcon style="width: 32px; height: 32px" />
                                <span>{{ $t("fastWizard.platformWordPress") }}</span>
                                <span></span>
                            </div>
                            <div class="content" v-if="selectedPlatform2 === 'wordpress'">
                                <div>{{ $t("fastWizard.installationInstructionsWordPress1") }}</div>
                                <div>{{ $t("fastWizard.installationInstructionsWordPress2") }}</div>
                                <div>{{ $t("fastWizard.installationInstructionsWordPress3") }}</div>
                                <div>
                                    {{
                                        $t("fastWizard.installationInstructionsWordPress4", {
                                            bodyTag: "<" + "/" + "body>",
                                        })
                                    }}
                                </div>
                                <div>{{ $t("fastWizard.installationInstructionsWordPress5") }}</div>
                            </div>
                        </div>
                        <div
                            class="platform platform-integration"
                            @click.stop="selectedPlatform2 = selectedPlatform2 === 'opencart' ? null : 'opencart'"
                            :class="{ selected: selectedPlatform === 'opencart' }"
                        >
                            <div class="header">
                                <OpenCartIcon style="width: 110px; height: 42px" />
                                <span style="margin-right: 80px">{{ $t("fastWizard.platformOpenCart") }}</span>
                                <span></span>
                            </div>
                            <div class="content" v-if="selectedPlatform2 === 'opencart'">
                                <div>{{ $t("fastWizard.installationInstructionsOpenCart1") }}</div>
                                <div>{{ $t("fastWizard.installationInstructionsOpenCart2") }}</div>
                                <div>{{ $t("fastWizard.installationInstructionsOpenCart3") }}</div>
                                <div>
                                    {{
                                        $t("fastWizard.installationInstructionsOpenCart4", {
                                            headTag: "<" + "/" + "head>",
                                        })
                                    }}
                                </div>
                                <div>{{ $t("fastWizard.installationInstructionsOpenCart5") }}</div>
                            </div>
                            <br />
                        </div>
                        <div
                            class="platform platform-integration"
                            @click.stop="selectedPlatform2 = selectedPlatform2 === 'ticimax' ? null : 'ticimax'"
                            :class="{ selected: selectedPlatform === 'ticimax' }"
                        >
                            <div class="header">
                                <TicimaxIcon style="width: 100px; height: 42px" />
                                <span style="margin-right: 80px">{{ $t("fastWizard.platformTicimax") }}</span>
                                <span></span>
                            </div>
                            <div class="content" v-if="selectedPlatform2 === 'ticimax'">
                                <div>{{ $t("fastWizard.installationInstructionsTicimax1") }}</div>
                                <div>{{ $t("fastWizard.installationInstructionsTicimax2") }}</div>
                                <div>{{ $t("fastWizard.installationInstructionsTicimax3") }}</div>
                                <div>
                                    {{ $t("fastWizard.installationInstructionsTicimax4") }}
                                </div>
                            </div>
                        </div>
                        <div
                            class="platform platform-integration"
                            @click.stop="
                                selectedPlatform2 = selectedPlatform2 === 'eticaretteyim' ? null : 'eticaretteyim'
                            "
                            :class="{ selected: selectedPlatform === 'eticaretteyim' }"
                        >
                            <div class="header">
                                <EticaretteyimIcon style="width: 100px; height: 40px" />
                                <span style="margin-right: 80px">{{ $t("fastWizard.platformEticaretteyim") }}</span>
                                <span></span>
                            </div>
                            <div class="content" v-if="selectedPlatform2 === 'eticaretteyim'">
                                <div>{{ $t("fastWizard.installationInstructionsEticaretteyim1") }}</div>
                                <div>{{ $t("fastWizard.installationInstructionsEticaretteyim2") }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
        </div>
        <div>
            <div class="right integration-control">
                <h4 class="mt-2">{{ $t("fastWizard.installationVerify") }}</h4>
                <div class="d-flex align-items-center items-web">
                    <md-field style="margin-top: 22px">
                        <label>{{ $t("fastWizard.websiteFieldLabel") }}</label>
                        <md-input v-model="website"></md-input>
                    </md-field>
                    <a-button
                        type="primary"
                        class="ml-1 btnColor"
                        @click="checkStatus"
                        :disabled="checking"
                        danger
                        ghost
                    >
                        {{
                            checking
                                ? $t("fastWizard.installationVerifyChecking")
                                : $t("fastWizard.installationVerifyCheck")
                        }}
                    </a-button>
                </div>
                <div v-if="checking" class="text-info p-2 border-info text-loading">
                    <a-icon type="loading" />
                    {{ $t("fastWizard.installationVerifyCheckingStatus", { website: website }) }}
                </div>
                <div v-else>
                    <a-result
                        :title="$t('fastWizard.installationCheckingStatusMessageYes', { website: website })"
                        v-if="isIntegrated"
                    >
                        <template #icon>
                            <a-icon type="smile" theme="twoTone" :twoToneColor="iconColor" />
                        </template>
                        <template #extra></template>
                    </a-result>
                    <div v-else>
                        <a-alert
                            :message="$t('fastWizard.installationCheckingStatusMessageNo', { website: website })"
                            banner
                            v-if="!isShopify()"
                        />
                    </div>
                </div>

                <a-alert
                    v-if="isShopify()"
                    type="success"
                    show-icon
                    message="Configuration Completed"
                    description="Yeah , you are SHOPIFY merchant 🎉🎉🎉.  Zero Configuration for Shopify users, supsis is auto integrated your website."
                    banner
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { createScreenshot } from "../../api/screenshot";
import { sendSocketMessage } from "../../utils/socketStream";
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-markup";
import "prismjs/themes/prism-tomorrow.css";
import JSIcon from "./svg/JSIcon";
import ShopifyIcon from "./svg/ShopifyIcon";
import WordPressIcon from "./svg/WordPressIcon";
import OpenCartIcon from "./svg/OpenCartIcon";
import TicimaxIcon from "./svg/TicimaxIcon";
import AmeriCommerceIcon from "./svg/AmeriCommerceIcon";
import BigCommerceIcon from "./svg/BigCommerceIcon";
import PrestaShopIcon from "./svg/PrestaShopIcon";
import EticaretteyimIcon from "./svg/EticaretteyimIcon";
import { checkIntegrationStatus } from "../../api/site";
import log2 from "../../utils/log2"; // import syntax highlighting styles
const log = log2("InstallCode");
log("languages", languages);
export default {
    name: "InstallCode",
    components: {
        PrismEditor,
        JSIcon,
        ShopifyIcon,
        WordPressIcon,
        OpenCartIcon,
        AmeriCommerceIcon,
        BigCommerceIcon,
        PrestaShopIcon,
        TicimaxIcon,
        EticaretteyimIcon,
    },
    data() {
        return {
            selectedPlatform: null,
            selectedPlatform2: null,
            isIntegrated: false,
            checking: false,
            iconColor: "#52c41a",
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            languages: (state) => state.language.languages,
            settingInitialized: (state) => state.setting.initialized,
        }),
        website: {
            get() {
                return this.settings.website;
            },
            async set(value) {
                this.changeWebsite((value || "").trim());
            },
        },
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        isShopify() {
            return _.get(this.site, "partner.name") === "shopify";
        },
        changeWebsite: _.debounce(async function (website) {
            if (this.settings.website === website) return;
            createScreenshot(website);
            const newSettings = await this.setSettingValue({
                setting: "website",
                value: website,
            });

            this.applySettings(newSettings);
            this.checkStatus();
        }, 1000),
        copyTextToClipboard() {
            const el = document.createElement("textarea");
            el.value = this.integrationScript();
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
            this.$message.success(this.$t("fastWizard.installationInstructionsCoppyMessage"));
        },

        applySettings(newSettings) {
            this.updateSettings(newSettings).then(() => {
                sendSocketMessage("user settings-updated", {
                    siteId: this.site._id,
                });
            });
        },
        highlighter(code) {
            return highlight(code, languages.markup); // languages.<insert language> to return html with markup
        },

        integrationScript() {
            const isProduction = process.env.PRODUCTION === "true";
            const hostname = this.site.customerClientAddress;
            const protocol = isProduction ? "https" : "http";
            const path = isProduction ? "static/js/loader.js" : "loader.js";
            const commandHandlerScript =
                `<script>window.supsis=window.supsis||function(){(supsis.q=supsis.q||[]).push(arguments)};supsis.l=+new Date;` +
                ["<", "/", "script>"].join("").concat("\n");
            return (
                `<!-- Start of SUPSIS Embed Code --> \n` +
                commandHandlerScript +
                `<script src=\"${protocol}://${hostname}/${path}\" type=\"text/javascript\" async defer>` +
                ["<", "/", "script>"].join("") +
                `\n<!-- End of SUPSIS Embed Code --> \n`
            );
        },
        checkStatus() {
            this.checking = true;
            checkIntegrationStatus(this.website)
                .then((isIntegrated) => {
                    this.isIntegrated = isIntegrated;
                })
                .finally(() => {
                    this.checking = false;
                });
        },
    },
    mounted() {
        this.checkStatus();
        if (
            !!document.getElementById("popoverHelpMenuOpened") &&
            !!document.getElementById("popoverHelpMenuOpened").style &&
            !document.getElementById("popoverHelpMenuOpened").style.display
        ) {
            document.getElementById("popoverHelpMenu").click();
        }
    },
    watch: {
        settings: {
            handler: function (newSettings) {},
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.my-editor {
    /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
    background: #f7f7f7;
    color: #ccc;

    /* you must provide font-family font-size line-height. Example: */
    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 14px;
    line-height: 1.5;
    padding: 5px;
    height: 160px;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
    outline: none;
}

.quick-installation {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    border: 1px solid darkgray;
}

.integration-control {
    margin-left: 50px !important;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    border: 1px solid darkgray;
}

.platforms-container {
    padding-top: 20px;
}

.platform-content {
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    margin-bottom: 10px;
    background: #fff;
}

.platform-integration {
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    margin-bottom: 10px;
    background: #fff;
}

.dark-mode .platform-content {
    border: 1px solid darkgray;
    background: #343441;
}

.dark-mode .platform-integration {
    border: 1px solid darkgray;
    border-radius: 6px;
    margin-bottom: 10px;
    background: #343441;
}

.dark-mode #install-code .platforms .platform .content {
    color: #ffffff !important;
    background: #343441;
}

.dark-mode .quick-installation {
    background: #343441;
    padding: 20px;
    border-radius: 4px;
    border: 1px solid darkgray;
}

.dark-mode .integration-control {
    margin-left: 50px !important;
    padding: 20px;
    background: #343441;
    border-radius: 4px;
    border: 1px solid darkgray;
}

.dark-mode .ant-btn {
    ackground-color: #1e1e2d !important;
    color: #ffffff;
    border: 1px solid darkgray;
}

.dark-mode .ant-alert-info {
    background-color: #e6f7ff;
    border: 1px solid darkgray;
}

.text-loading {
    color: var(--color-bg-primary-default) !important;
}

.btnColor {
    border-color: var(--color-bg-primary-default) !important;
    color: var(--color-bg-primary-default) !important;
}

.down-arrow {
    color: var(--color-bg-primary-default) !important;
}

#install-code .platforms .platform.selected {
    border: 1px solid darkgray !important;
}

@media (max-width: 1200px) {
    #install-code {
        display: block;
        width: 100%;
    }
    #install-code .left {
        width: 100%;
        margin: auto;
    }
    #install-code .right {
        width: 100%;
        margin: 0px !important;
        margin-bottom: 50px !important;
    }
    .items-web {
        display: block !important;
        margin-bottom: 20px;
    }
}

@media (max-width: 768px) {
    #install-code {
        display: block;
        width: 100%;
    }
    #install-code .left {
        width: 100%;
        margin: auto;
    }
    #install-code .right {
        width: 100%;
        margin-bottom: 50px;
        margin: 0px !important;
        margin-bottom: 50px !important;
    }
    .items-web {
        display: block !important;
        margin-bottom: 20px;
    }
}
</style>
